import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    textCenter: {
        display: 'flex',
        textAlign: 'center',
        justifyContent: 'center',
    }
}));
